<div>
    <div (onFileDrop)="onFileDrop($event)" ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
        (fileOver)="fileOverBase($event)" [uploader]="uploader" class="drop-zone"
        [class.filled]="file" [class.error]="hasError">
        <p class="trigger" *ngIf="!file" (click)="input.nativeElement.click()">
            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.5 20C1.95 20 1.47933 19.8043 1.088 19.413C0.696 19.021 0.5 18.55 0.5 18V2C0.5 1.45 0.696 0.979 1.088 0.587C1.47933 0.195667 1.95 0 2.5 0H10.5L16.5 6V18C16.5 18.55 16.3043 19.021 15.913 19.413C15.521 19.8043 15.05 20 14.5 20H2.5ZM9.5 7V2H2.5V18H14.5V7H9.5Z"
                    fill="#383B43" />
            </svg>
            &nbsp;
           <span class="import-text">Import CSV file</span>
        </p>
        <p class="trigger" *ngIf="file"  (click)="input.nativeElement.click()">
            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 20C1.95 20 1.47933 19.8043 1.088 19.413C0.696 19.021 0.5 18.55 0.5 18V2C0.5 1.45 0.696 0.979 1.088 0.587C1.47933 0.195667 1.95 0 2.5 0H10.5L16.5 6V18C16.5 18.55 16.3043 19.021 15.913 19.413C15.521 19.8043 15.05 20 14.5 20H2.5ZM9.5 7V2H2.5V18H14.5V7H9.5Z" fill="#383B43"/>
                </svg>
                &nbsp;{{ file?.file?.name }}<span *ngIf="hasError" class="bold">, try again!</span>
        </p>
    </div>

    <p class="error-text" *ngIf="hasError">
        <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 19L11 0L22 19H0ZM3.45 17H18.55L11 4L3.45 17ZM11 16C11.2833 16 11.521 15.904 11.713 15.712C11.9043 15.5207 12 15.2833 12 15C12 14.7167 11.9043 14.4793 11.713 14.288C11.521 14.096 11.2833 14 11 14C10.7167 14 10.4793 14.096 10.288 14.288C10.096 14.4793 10 14.7167 10 15C10 15.2833 10.096 15.5207 10.288 15.712C10.4793 15.904 10.7167 16 11 16ZM10 13H12V8H10V13Z" fill="#BA1A1A"/>
            </svg>
           &nbsp; Your CSV is not correct.
    </p>

    <input #fileInput type="file" ng2FileSelect [uploader]="uploader" (change)="onFileDrop($event)" />
</div>